import { RegisterCustomerAction } from './actions';

import {
  REGISTER_CUSTOMER_REQUEST_START,
  REGISTER_CUSTOMER_REQUEST_FAIL,
  REGISTER_CUSTOMER_REQUEST_SUCCESS,
  UPDATE_REGISTER_CUSTOMER_STATUS_TO_INITIAL,
  SEND_SKIP_DOCUMENT_EMAIL_START,
  SEND_SKIP_DOCUMENT_EMAIL_FAIL,
  SEND_SKIP_DOCUMENT_EMAIL_SUCCESS
} from './types';

type RegisterCustomerState = {
  customer_state: any,
  loadingState: string,
  skipDocumentsSendEmail: any,
};

const INITIAL_STATE: RegisterCustomerState = {
  customer_state: null,
  loadingState: 'UNINITIALISED',
  skipDocumentsSendEmail: null,
};

export const reducer = (
  state = INITIAL_STATE,
  action: RegisterCustomerAction
): RegisterCustomerState => {
  switch (action.type) {
    case REGISTER_CUSTOMER_REQUEST_START:
      return {
        ...state,
        customer_state: null,
        loadingState: 'LOADING'
      };

    case REGISTER_CUSTOMER_REQUEST_SUCCESS:
      return {
        ...state,
        customer_state: action.payload,
        loadingState: 'LOADED'
      };

    case REGISTER_CUSTOMER_REQUEST_FAIL:
      return {
        ...state,
        customer_state: null,
        loadingState: action.payload && (action.payload === 'CUSTOMER_STATE_FAIL' || action.payload === 'POLLING_COMPLETE') ?
                        action.payload : 'ERROR'
      };

  case UPDATE_REGISTER_CUSTOMER_STATUS_TO_INITIAL:
    return {
      ...state,
      customer_state: null,
      loadingState: 'UNINITIALISED',
    };

    case SEND_SKIP_DOCUMENT_EMAIL_START:
      return {
        ...state,
        loadingState: 'LOADING'
      };

    case SEND_SKIP_DOCUMENT_EMAIL_FAIL:
      return {
        ...state,
        loadingState: 'ERROR'
      };

    case SEND_SKIP_DOCUMENT_EMAIL_SUCCESS:
      return {
        ...state,
        loadingState: 'LOADED',
        skipDocumentsSendEmail: action.payload
      };

    default:
      return state;
  }
};